export enum RatingSummaryType {
    TrustYou = 'trustYou',
    Guest = 'guest',
    Combined = 'combined',
}

export const getRatingSummaryType = (
    hasTrustYouList: boolean,
    hasRatingDetailList: boolean,
    hasUserRatingList: boolean
): RatingSummaryType => {
    if (hasRatingDetailList) {
        return RatingSummaryType.Guest;
    } else if (hasTrustYouList && !hasUserRatingList) {
        return RatingSummaryType.TrustYou;
    } else {
        return RatingSummaryType.Combined;
    }
};
